import React from "react";

const PhoneCall = ({ width = "54px", height = "54px" }) => (
  <svg
    className="fill-current"
    width={width}
    height={height}
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.0831 75.8649C36.0831 75.8649 14.8444 68.6101 18.4587 45.9872C20.4868 35.1596 33.8358 16.2042 61.9515 28.4684C68.0484 30.9149 74.736 28.8679 85.2354 21.715C93.8753 15.6072 107.535 12.3617 120.144 30.4838C124.708 37.0506 144.818 70.0349 116.955 87.3816C114.759 127.492 39.3583 136.55 36.0831 75.8649"
      fill="#FFE29B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.6261 99.6406C30.9715 99.6406 30.4403 99.1077 30.4403 98.4539V52.2125C30.4403 51.5578 30.9715 51.0258 31.6261 51.0258H110.029C110.684 51.0258 111.216 51.5578 111.216 52.2125V98.4539C111.216 99.1077 110.684 99.6406 110.029 99.6406H31.6261Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M110.03 50.3867H31.6264C30.6174 50.3867 29.7994 51.2037 29.7994 52.2119V98.4542C29.7994 99.4624 30.6174 100.279 31.6264 100.279H110.03C111.037 100.279 111.855 99.4624 111.855 98.4542V52.2119C111.855 51.2037 111.037 50.3867 110.03 50.3867M110.03 51.6645C110.331 51.6645 110.577 51.9098 110.577 52.2119V98.4542C110.577 98.7563 110.331 99.0016 110.03 99.0016H31.6264C31.3243 99.0016 31.0781 98.7563 31.0781 98.4542V52.2119C31.0781 51.9098 31.3243 51.6645 31.6264 51.6645H110.03"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.5757 93.9278C36.921 93.9278 36.3899 93.3948 36.3899 92.741V46.4997C36.3899 45.845 36.921 45.312 37.5757 45.312H115.979C116.634 45.312 117.166 45.845 117.166 46.4997V92.741C117.166 93.3948 116.634 93.9278 115.979 93.9278H37.5757Z"
      fill="#FFCB05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M115.979 44.6736H37.576C36.5669 44.6736 35.749 45.4915 35.749 46.4997V92.7411C35.749 93.7493 36.5669 94.5672 37.576 94.5672H115.979C116.987 94.5672 117.805 93.7493 117.805 92.7411V46.4997C117.805 45.4915 116.987 44.6736 115.979 44.6736M115.979 45.9514C116.28 45.9514 116.527 46.1975 116.527 46.4996V92.741C116.527 93.0431 116.28 93.2884 115.979 93.2884H37.576C37.2739 93.2884 37.0277 93.0431 37.0277 92.741V46.4996C37.0277 46.1975 37.2739 45.9514 37.576 45.9514H115.979"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.0043 19.0657C22.0043 19.0657 22.0043 19.145 21.8474 19.2235C21.8474 19.2235 17.9968 20.4887 15.1679 23.2544C12.4166 26.0202 11.1595 29.9718 11.1595 29.9718C11.1595 30.1305 11.0026 30.1305 11.0026 30.1305C11.0026 30.1305 10.9241 30.1305 10.8448 29.9718C10.8448 29.9718 9.5868 26.0202 6.83728 23.2544C4.08686 20.4887 0.156909 19.2235 0.156909 19.2235C0 19.2235 0 19.0657 0 19.0657C0 19.0657 0 18.9872 0.156909 18.9079C0.156909 18.9079 4.0075 17.6427 6.83728 14.8769C9.5868 12.1112 10.8448 8.15957 10.8448 8.15957C10.8448 8.00085 11.0026 8.00085 11.0026 8.00085C11.0026 8.00085 11.1595 8.00085 11.1595 8.15957C11.1595 8.15957 12.4166 12.1112 15.1679 14.8769C17.9183 17.6427 21.8474 18.9079 21.8474 18.9079C22.0043 18.9872 22.0043 19.0657 22.0043 19.0657"
      fill="#FFCB05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M104.253 28.1184C104.253 28.1184 104.253 28.15 104.191 28.1815C104.191 28.1815 102.651 28.6874 101.519 29.793C100.42 30.8986 99.917 32.4785 99.917 32.4785C99.917 32.5416 99.8539 32.5416 99.8539 32.5416C99.8539 32.5416 99.8232 32.5416 99.7917 32.4785C99.7917 32.4785 99.2885 30.8986 98.1883 29.793C97.09 28.6874 95.5182 28.1815 95.5182 28.1815C95.4559 28.1815 95.4559 28.1184 95.4559 28.1184C95.4559 28.1184 95.4559 28.0869 95.5182 28.0553C95.5182 28.0553 97.0575 27.5494 98.1883 26.4438C99.2885 25.3382 99.7917 23.7583 99.7917 23.7583C99.7917 23.6952 99.8539 23.6952 99.8539 23.6952C99.8539 23.6952 99.917 23.6952 99.917 23.7583C99.917 23.7583 100.42 25.3382 101.519 26.4438C102.619 27.5494 104.191 28.0553 104.191 28.0553C104.253 28.0869 104.253 28.1184 104.253 28.1184"
      fill="#FFCB05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M65.05 134.484C65.05 134.484 65.05 134.531 64.9562 134.578C64.9562 134.578 62.6557 135.333 60.9658 136.986C59.3219 138.638 58.5707 140.999 58.5707 140.999C58.5707 141.094 58.4778 141.094 58.4778 141.094C58.4778 141.094 58.43 141.094 58.3831 140.999C58.3831 140.999 57.6319 138.638 55.9889 136.986C54.3468 135.333 51.9985 134.578 51.9985 134.578C51.9056 134.578 51.9056 134.484 51.9056 134.484C51.9056 134.484 51.9056 134.437 51.9985 134.39C51.9985 134.39 54.299 133.634 55.9889 131.982C57.6319 130.329 58.3831 127.968 58.3831 127.968C58.3831 127.875 58.4778 127.875 58.4778 127.875C58.4778 127.875 58.5707 127.875 58.5707 127.968C58.5707 127.968 59.3219 130.329 60.9658 131.982C62.6088 133.634 64.9562 134.39 64.9562 134.39C65.05 134.437 65.05 134.484 65.05 134.484"
      fill="#C00033"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9894 83.2198C15.9894 83.2198 15.9894 83.2513 15.9272 83.2829C15.9272 83.2829 14.3897 83.7879 13.2606 84.8917C12.1623 85.9963 11.66 87.5736 11.66 87.5736C11.66 87.6367 11.5978 87.6367 11.5978 87.6367C11.5978 87.6367 11.5662 87.6367 11.5346 87.5736C11.5346 87.5736 11.0323 85.9963 9.93488 84.8917C8.83652 83.7879 7.26742 83.2829 7.26742 83.2829C7.2052 83.2829 7.2052 83.2198 7.2052 83.2198C7.2052 83.2198 7.2052 83.1882 7.26742 83.1566C7.26742 83.1566 8.80495 82.6516 9.93488 81.5479C11.0323 80.4432 11.5346 78.866 11.5346 78.866C11.5346 78.8029 11.5978 78.8029 11.5978 78.8029C11.5978 78.8029 11.66 78.8029 11.66 78.866C11.66 78.866 12.1623 80.4432 13.2606 81.5479C14.3581 82.6516 15.9272 83.1566 15.9272 83.1566C15.9894 83.1882 15.9894 83.2198 15.9894 83.2198"
      fill="#C00033"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M149.999 65.8292C149.999 65.8292 149.999 65.8725 149.913 65.9166C149.913 65.9166 147.782 66.6164 146.216 68.1467C144.693 69.678 143.998 71.8648 143.998 71.8648C143.998 71.9532 143.911 71.9532 143.911 71.9532C143.911 71.9532 143.866 71.9532 143.823 71.8648C143.823 71.8648 143.128 69.678 141.605 68.1467C140.083 66.6164 137.908 65.9166 137.908 65.9166C137.821 65.9166 137.821 65.8292 137.821 65.8292C137.821 65.8292 137.821 65.785 137.908 65.7417C137.908 65.7417 140.039 65.041 141.605 63.5107C143.128 61.9795 143.823 59.7927 143.823 59.7927C143.823 59.7052 143.911 59.7052 143.911 59.7052C143.911 59.7052 143.998 59.7052 143.998 59.7927C143.998 59.7927 144.693 61.9795 146.216 63.5107C147.738 65.041 149.913 65.7417 149.913 65.7417C149.999 65.785 149.999 65.8292 149.999 65.8292"
      fill="#C00033"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M82.2579 110.934C82.2579 110.934 82.2579 110.962 82.202 110.99C82.202 110.99 80.8376 111.439 79.8339 112.42C78.8582 113.4 78.4127 114.801 78.4127 114.801C78.4127 114.857 78.3577 114.857 78.3577 114.857C78.3577 114.857 78.3298 114.857 78.3018 114.801C78.3018 114.801 77.8563 113.4 76.8806 112.42C75.9058 111.439 74.5125 110.99 74.5125 110.99C74.4575 110.99 74.4575 110.934 74.4575 110.934C74.4575 110.934 74.4575 110.906 74.5125 110.879C74.5125 110.879 75.8778 110.43 76.8806 109.45C77.8563 108.469 78.3018 107.068 78.3018 107.068C78.3018 107.012 78.3577 107.012 78.3577 107.012C78.3577 107.012 78.4127 107.012 78.4127 107.068C78.4127 107.068 78.8582 108.469 79.8339 109.45C80.8096 110.43 82.202 110.879 82.202 110.879C82.2579 110.906 82.2579 110.934 82.2579 110.934"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.7817 87.9231C43.127 87.9231 42.595 87.3902 42.595 86.7364V40.495C42.595 39.8403 43.127 39.3074 43.7817 39.3074H122.184C122.839 39.3074 123.372 39.8403 123.372 40.495V86.7364C123.372 87.3902 122.839 87.9231 122.184 87.9231H43.7817Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.184 38.6688H43.782C42.7729 38.6688 41.9559 39.4867 41.9559 40.4949V86.7363C41.9559 87.7445 42.7729 88.5624 43.782 88.5624H122.184C123.194 88.5624 124.011 87.7445 124.011 86.7363V40.4949C124.011 39.4867 123.194 38.6688 122.184 38.6688M122.184 39.9466C122.487 39.9466 122.732 40.1928 122.732 40.4949V86.7362C122.732 87.0383 122.487 87.2836 122.184 87.2836H43.782C43.4799 87.2836 43.2337 87.0383 43.2337 86.7362V40.4949C43.2337 40.1928 43.4799 39.9466 43.782 39.9466H122.184"
      fill="black"
    />
    <path
      d="M43.7394 40.154L80.2858 77.1612C81.7701 78.6663 84.1986 78.669 85.6874 77.1666L122.548 39.9637"
      stroke="black"
      strokeWidth="1.417"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.3881 87.1685L67.0038 63.4977Z"
      fill="white"
    />
    <path
      d="M43.3881 87.1685L67.0038 63.4977"
      stroke="black"
      strokeWidth="1.417"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M122.752 87.1685L98.8896 63.2516Z"
      fill="white"
    />
    <path
      d="M122.752 87.1685L98.8896 63.2516"
      stroke="black"
      strokeWidth="1.417"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.3466 100.28H64.4318V97.9116H58.3466V100.28Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.4152 41.0364H103.5V38.6683H97.4152V41.0364Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M109.553 75.665L105.25 71.3617L106.924 69.688L111.227 73.9904L109.553 75.665Z"
      fill="white"
    />
  </svg>
);

export default PhoneCall;
